import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import * as React from 'react';
import Modal from 'styled-react-modal';
import { SocialShareModalBase } from './SocialShareModalBase';
export var SocialShareModal = function (_React$Component) {
  _inherits(SocialShareModal, _React$Component);

  var _super = _createSuper(SocialShareModal);

  function SocialShareModal(props, _) {
    var _this;

    _classCallCheck(this, SocialShareModal);

    _this = _super.call(this, props);

    _this.close = function () {
      _this.setState({
        isOpen: false
      });
    };

    _this.open = function () {
      _this.setState({
        isOpen: true
      });
    };

    _this.state = {
      isOpen: false,
      showCopySuccessMessage: false
    };
    return _this;
  }

  _createClass(SocialShareModal, [{
    key: "render",
    value: function render() {
      return React.createElement(Modal, {
        isOpen: this.state.isOpen,
        onBackgroundClick: this.close
      }, React.createElement(SocialShareModalBase, _extends({}, this.props, {
        onCloseModal: this.close
      })));
    }
  }]);

  return SocialShareModal;
}(React.Component);
SocialShareModal.SOCIAL_SHARE_MODAL_NAME = 'SOCIAL_SHARE_MODAL';